import { chainCommands, deleteSelection, joinBackward, selectNodeBackward, newlineInCode, createParagraphNear, liftEmptyBlock, splitBlockKeepMarks, exitCode } from 'prosemirror-commands';
import { undo, redo } from 'prosemirror-history';
import { undoInputRule } from 'prosemirror-inputrules';
import { splitListItemKeepMarks } from '../lists.js';
import { bold, italic, underline } from './commands.js';
import { toggleInlineFormat } from '../inline-style.js';
import { expandToWordWrap } from '../utils.js';

const mac = typeof navigator !== 'undefined' ? /Mac/.test(navigator.platform) : false;
// https://github.com/ProseMirror/prosemirror-example-setup/blob/master/src/keymap.js
const buildKeymap = (schema, options) => {
    const keys = {};
    const applyToWord = (options && options.applyToWord) || false;
    keys['Mod-z'] = undo;
    keys['Shift-Mod-z'] = redo;
    // tslint:disable-next-line:no-string-literal
    keys.Backspace = chainCommands(undoInputRule, deleteSelection, joinBackward, selectNodeBackward);
    // tslint:disable-next-line:no-string-literal
    keys.Enter = chainCommands(newlineInCode, createParagraphNear, liftEmptyBlock, splitBlockKeepMarks);
    if (!mac) {
        keys['Mod-y'] = redo;
    }
    if (schema.marks.strong) {
        keys['Mod-b'] = expandToWordWrap(toggleInlineFormat, { ...bold, applyToWord });
    }
    if (schema.marks.em) {
        keys['Mod-i'] = expandToWordWrap(toggleInlineFormat, { ...italic, applyToWord });
    }
    if (schema.marks.u) {
        keys['Mod-u'] = expandToWordWrap(toggleInlineFormat, { ...underline, applyToWord });
    }
    if (schema.nodes.hard_break) {
        const br = schema.nodes.hard_break;
        const cmd = chainCommands(exitCode, (state, dispatch) => {
            dispatch(state.tr.replaceSelectionWith(br.create()).scrollIntoView());
            return true;
        });
        keys['Shift-Enter'] = cmd;
    }
    return keys;
};
const buildListKeymap = (schema) => {
    const keys = {};
    if (schema.nodes.list_item) {
        // tslint:disable-next-line:no-string-literal
        keys.Enter = splitListItemKeepMarks(schema.nodes.list_item);
    }
    return keys;
};

export { buildKeymap, buildListKeymap };
